import React from 'react';

const TokenContext = React.createContext(null);

export default TokenContext;
